import { MagnifyingGlassMinusIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Zoomout = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <MagnifyingGlassMinusIcon {...rest} size={Sizes[size]} color={fill} />;
};

Zoomout.displayName = 'Zoomout';
